var map = {
	"./024-like.svg": 381,
	"./1.svg": 382,
	"./155-credit-card.svg": 383,
	"./2.svg": 384,
	"./3.svg": 385,
	"./4.svg": 386,
	"./New Customer.svg": 375,
	"./NotOpen.svg": 387,
	"./Opened.svg": 388,
	"./Profit.svg": 376,
	"./SalesRevenue.svg": 377,
	"./Sent.svg": 389,
	"./Slack.svg": 390,
	"./address.svg": 391,
	"./adobe.svg": 392,
	"./arrow-left.svg": 393,
	"./arrow-right.svg": 394,
	"./book.svg": 395,
	"./camera.svg": 396,
	"./chat.svg": 397,
	"./clipboard.svg": 398,
	"./cloud.svg": 399,
	"./columns.svg": 246,
	"./documentation.svg": 400,
	"./file.svg": 401,
	"./flat.svg": 402,
	"./headphone.svg": 403,
	"./iconfinder_trello_2317760.svg": 404,
	"./idea.svg": 405,
	"./image.svg": 407,
	"./layers.svg": 408,
	"./left.svg": 409,
	"./logo2.svg": 410,
	"./logo3.svg": 411,
	"./logo4.svg": 412,
	"./logo5.svg": 413,
	"./logo6.svg": 414,
	"./logoIn.svg": 415,
	"./paint.svg": 416,
	"./protection.svg": 417,
	"./repeat.svg": 247,
	"./right.svg": 373,
	"./strategy.svg": 418,
	"./theme.svg": 419,
	"./user.svg": 420,
	"./water-fall.svg": 421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1182;